type JobDetailApiItem = {
  data?: {
    jobDetail?: {
      key?: string;
      title?: string;
      visible?: boolean;
      cta?: Array<{
        submitJobSection?: {
          key?: string;
          type?: string;
          author?: string;
          status?: string;
          visible?: boolean;
          content?: Array<{
            headerSection?: {
              key?: string;
              label?: string;
              title?: string;
              visible?: boolean;
              description?: string;
              subDescription?: string;
              button?: {
                label?: string;
              };
            };
          }>;
        };
      }>;
    };
  };
};

export type NormalizedJobDetail = {
  page: "jobDetail";
  title: string;
  visible: boolean;

  section: {
    visible: boolean;
  };

  header: {
    label: string;
    title: string;
    description: string;
    subDescription: string;
    visible: boolean;
    buttonLabel: string;
  };

  meta: {
    key: string;
  };
};

export function normalizeJobDetail(
  item: JobDetailApiItem
): NormalizedJobDetail | null {
  const jobDetail = item?.data?.jobDetail;
  const cta = jobDetail?.cta?.[0];
  const section = cta?.submitJobSection;
  const content = section?.content?.[0];
  const header = content?.headerSection;

  if (!jobDetail || !cta || !section || !content || !header) return null;

  return {
    page: "jobDetail",
    title: jobDetail.title ?? "",
    visible: Boolean(jobDetail.visible),

    section: {
      visible: Boolean(section.visible),
    },

    header: {
      label: header.label ?? "",
      title: header.title ?? "",
      description: header.description ?? "",
      subDescription: header.subDescription ?? "",
      visible: Boolean(header.visible),
      buttonLabel: header.button?.label ?? "",
    },

    meta: {
      key: jobDetail.key ?? "",
    },
  };
}